var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Page", {
        attrs: { title: _vm.pageTitle, isFullWidth: true },
        scopedSlots: _vm._u([
          {
            key: "action",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "Polaris-Page-Header__PrimaryActionWrapper" },
                  [
                    _c(
                      "div",
                      { staticClass: "Polaris-Box Polaris-Box--printHidden" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "Polaris-Button mr-2",
                            attrs: { type: "button" },
                            on: { click: _vm.openTemplates }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "Polaris-Button__Content" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "Polaris-Button__Text" },
                                  [_vm._v("Templates")]
                                )
                              ]
                            )
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass:
                              "Polaris-Button Polaris-Button--primary",
                            attrs: { type: "button", disabled: _vm.isLoading },
                            on: { click: _vm.refreshCurrentPage }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "Polaris-Button__Content" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "Polaris-Button__Text" },
                                  [_vm._v("Refresh")]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]
            },
            proxy: true
          },
          {
            key: "default",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "flex flex-col max-w-7xl mx-auto my-10" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
                      },
                      [
                        _vm.isLoading
                          ? _c("div", [_c("Spinner")], 1)
                          : _vm._e(),
                        _c("div", { staticClass: "flex flex-col" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 "
                            },
                            [
                              _c("ManualMessageAlert"),
                              _vm.checkouts.docs &&
                              _vm.checkouts.docs.length > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "align-middle inline-block min-w-full shadow  sm:rounded-lg border-b border-gray-200 mb-8"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "Polaris-Card" },
                                        [
                                          _c("div", {}, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "Polaris-DataTable__Navigation"
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "Polaris-Button Polaris-Button--disabled Polaris-Button--plain Polaris-Button--iconOnly",
                                                    attrs: {
                                                      "aria-label":
                                                        "Scroll table left one column",
                                                      "aria-disabled": "true",
                                                      type: "button",
                                                      tabindex: "-1"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "Polaris-Button__Content"
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "Polaris-Button__Icon"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "Polaris-Icon"
                                                              },
                                                              [
                                                                _c("span", {
                                                                  staticClass:
                                                                    "Polaris-Text--root Polaris-Text--bodySm Polaris-Text--regular Polaris-Text--visuallyHidden"
                                                                }),
                                                                _c(
                                                                  "svg",
                                                                  {
                                                                    staticClass:
                                                                      "Polaris-Icon__Svg",
                                                                    attrs: {
                                                                      viewBox:
                                                                        "0 0 20 20",
                                                                      focusable:
                                                                        "false",
                                                                      "aria-hidden":
                                                                        "true"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("path", {
                                                                      attrs: {
                                                                        d:
                                                                          "M12 16a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 0 1 0-1.414l5-5a.999.999 0 1 1 1.414 1.414l-4.293 4.293 4.293 4.293a.999.999 0 0 1-.707 1.707z"
                                                                      }
                                                                    })
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "Polaris-Button Polaris-Button--plain Polaris-Button--iconOnly",
                                                    attrs: {
                                                      "aria-label":
                                                        "Scroll table right one column",
                                                      type: "button"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "Polaris-Button__Content"
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "Polaris-Button__Icon"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "Polaris-Icon"
                                                              },
                                                              [
                                                                _c("span", {
                                                                  staticClass:
                                                                    "Polaris-Text--root Polaris-Text--bodySm Polaris-Text--regular Polaris-Text--visuallyHidden"
                                                                }),
                                                                _c(
                                                                  "svg",
                                                                  {
                                                                    staticClass:
                                                                      "Polaris-Icon__Svg",
                                                                    attrs: {
                                                                      viewBox:
                                                                        "0 0 20 20",
                                                                      focusable:
                                                                        "false",
                                                                      "aria-hidden":
                                                                        "true"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("path", {
                                                                      attrs: {
                                                                        d:
                                                                          "M8 16a.999.999 0 0 1-.707-1.707l4.293-4.293-4.293-4.293a.999.999 0 1 1 1.414-1.414l5 5a.999.999 0 0 1 0 1.414l-5 5a.997.997 0 0 1-.707.293z"
                                                                      }
                                                                    })
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "Polaris-DataTable Polaris-DataTable__ShowTotals overflow-hidden"
                                              },
                                              [
                                                _c("div", {}, [
                                                  _c(
                                                    "table",
                                                    {
                                                      staticClass:
                                                        "Polaris-DataTable__Table"
                                                    },
                                                    [
                                                      _c("thead", [
                                                        _c(
                                                          "tr",
                                                          {
                                                            staticClass:
                                                              "hidden md:table-row"
                                                          },
                                                          [
                                                            _c(
                                                              "th",
                                                              {
                                                                staticClass:
                                                                  "Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header",
                                                                attrs: {
                                                                  "data-polaris-header-cell":
                                                                    "true",
                                                                  scope: "col"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Customer "
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "th",
                                                              {
                                                                staticClass:
                                                                  "Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header ",
                                                                attrs: {
                                                                  "data-polaris-header-cell":
                                                                    "true",
                                                                  scope: "col"
                                                                }
                                                              },
                                                              [_vm._v(" Date ")]
                                                            ),
                                                            _c(
                                                              "th",
                                                              {
                                                                staticClass:
                                                                  "Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header ",
                                                                attrs: {
                                                                  "data-polaris-header-cell":
                                                                    "true",
                                                                  scope: "col"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Recovery Status "
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "th",
                                                              {
                                                                staticClass:
                                                                  "Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header ",
                                                                attrs: {
                                                                  "data-polaris-header-cell":
                                                                    "true",
                                                                  scope: "col"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Message Status "
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "th",
                                                              {
                                                                staticClass:
                                                                  "Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header ",
                                                                attrs: {
                                                                  "data-polaris-header-cell":
                                                                    "true",
                                                                  scope: "col"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Checkout id "
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "th",
                                                              {
                                                                staticClass:
                                                                  "Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header ",
                                                                attrs: {
                                                                  "data-polaris-header-cell":
                                                                    "true",
                                                                  scope: "col"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Total & last order date "
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "th",
                                                              {
                                                                staticClass:
                                                                  "Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header ",
                                                                attrs: {
                                                                  "data-polaris-header-cell":
                                                                    "true",
                                                                  scope: "col"
                                                                }
                                                              },
                                                              [_vm._v(" Tags ")]
                                                            ),
                                                            _c("th", {
                                                              staticClass:
                                                                "Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header ",
                                                              attrs: {
                                                                "data-polaris-header-cell":
                                                                  "true",
                                                                scope: "col"
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]),
                                                      _c(
                                                        "tbody",
                                                        _vm._l(
                                                          _vm.checkouts.docs,
                                                          function(checkout) {
                                                            return _c(
                                                              "CartListItem",
                                                              {
                                                                key:
                                                                  checkout.id,
                                                                attrs: {
                                                                  checkout: checkout
                                                                },
                                                                on: {
                                                                  refreshCurrentPage:
                                                                    _vm.refreshCurrentPage,
                                                                  openCustomerInfo:
                                                                    _vm.openCustomerInfo
                                                                }
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      )
                                                    ]
                                                  )
                                                ]),
                                                _c("Pagination", {
                                                  attrs: {
                                                    page: _vm.checkouts
                                                  },
                                                  on: {
                                                    pageChanged: _vm.loadPage
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              !_vm.isLoading &&
                              _vm.checkouts.docs &&
                              _vm.checkouts.docs.length === 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "align-middle inline-block min-w-full  overflow-hidden text-center py-16"
                                    },
                                    [
                                      _vm._v(
                                        " You don't have any abandoned carts right now. We will be listing them here as soon a cart is abandoned. "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]),
                        _vm.showCustomerInfoModal
                          ? _c("CustomerInfoModal", {
                              attrs: {
                                phoneNumber: _vm.currentCustomerPhoneNumber
                              },
                              on: { close: _vm.closeCustomerInfo }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }